import { useState, useEffect } from "react";
import {
  Flex,
  Text,
  Heading,
  Menu,
  Button,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Center,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { Masonry } from "masonic";
import PuffLoader from "react-spinners/PuffLoader";
import Tweet from "components/tweets/masonry/tweet";
import { textStyle } from "theme/names";

export function MostResults({ stats = [], isLoading: propsIsLoading = false }) {
  const [data, setData] = useState<any>();
  const [filteredData, setFilteredData] = useState<any>();
  const [type, setType] = useState<string>("Followers");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const compare = (a, b) => {
    const pair = {
      Followers: "user_profile_clicks",
      Reach: "impression_count",
    };
    if (type !== "Engagement") {
      if (a.non_public_metrics[pair[type]] < b.non_public_metrics[pair[type]]) {
        return 1;
      }
      if (a.non_public_metrics[pair[type]] > b.non_public_metrics[pair[type]]) {
        return -1;
      }
      return 0;
    } else {
      if (
        a.public_metrics.total_engagement < b.public_metrics.total_engagement
      ) {
        return 1;
      }
      if (
        a.public_metrics.total_engagement > b.public_metrics.total_engagement
      ) {
        return -1;
      }
      return 0;
    }
  };

  const performFiltering = () => {
    const copyOfData = [...data];
    const sortedData = copyOfData.sort(compare);
    setFilteredData(sortedData.slice(0, 3));
  };

  // executed on first load and on timeframe change
  useEffect(() => {
    if (data) {
      performFiltering();
    }
  }, [data]);

  // filter on type change
  useEffect(() => {
    if (data) {
      setIsLoading(true);
      performFiltering();
      setTimeout(() => {
        setIsLoading(false);
      }, 800);
    }
  }, [type]);

  useEffect(() => {
    if (stats && stats?.length > 0) {
      setData([...stats]);
    } else {
      setData([]);
    }
  }, [stats]);

  const loading = isLoading || propsIsLoading;

  return (
    <Box>
      <Flex alignItems="center" wrap="wrap">
        <Text
          textStyle={textStyle["h2.bold.standard"]}
          // fontSize="xl" fontWeight="600"
        >
          Tweets that generated the most
        </Text>
        <Menu variant={"secondary"}>
          <MenuButton
            as={Button}
            // size="sm"
            variant={"secondary"}
            rightIcon={<ChevronDownIcon />}
            marginX="4"
            mt={{ base: "4", md: "0" }}
          >
            {type}
          </MenuButton>
          <MenuList maxH="215px">
            {["Followers", "Engagement", "Reach"].map((x) => (
              <MenuItem
                key={x}
                onClick={async (e) => {
                  setType(x);
                }}
              >
                {x}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        {type === "Followers" && (
          <Text
            // as="i"
            textStyle={textStyle["body.medium.inactive"]}
            fontSize="xs"
            mt={{ base: "4", md: "0" }}
          >
            based on profile visits
          </Text>
        )}
      </Flex>
      {loading && (
        <Center pt={10} h="400px">
          <PuffLoader
            color={"hsl(203, 100%, 36%)"}
            loading={loading}
            css="display: block; margin: 0 auto; border-color: red;"
            size={50}
          />
        </Center>
      )}
      {!loading &&
        (filteredData && filteredData?.length > 0 ? (
          <Box
            mt="12"
            // pl={{ base: "0", md: "10" }}
          >
            <Masonry
              key={filteredData?.length}
              items={filteredData}
              columnWidth={260}
              columnGutter={24}
              // @ts-ignore
              render={(tweet) => <Tweet tweet={tweet} />}
            />
          </Box>
        ) : (
          <Text mt="8" textAlign="center">
            No tweets found. Please try a different time frame.
          </Text>
        ))}
    </Box>
  );
}
